import React from 'react'
import SceneWrapper from '../components/SceneWrapper'

function ScenePage () {
  return (
    <div className="App">
      <div className={'w-full h-body relative bg-transparent'}>
        <div className={'w-full h-body relative animation-fadeIn'}>
          <SceneWrapper />
        </div>
      </div>
    </div>
  )
}

export default ScenePage
